import React from 'react';
import Dialog from '../../common/components/Dialog';
import Notes from '../notes';

const NotesDialog = ({ t, child, show, onHide, onNotesUpdated }) => {
	if (!child) {
		return null;
	}

	const dialogConfig = {
		header: `${t('Child_Section_Notes')} - ${child.name}`,
		body: <Notes reference={child.id} referenceType='Child' onNoteAdded={onNotesUpdated} onNoteDeleted={onNotesUpdated} />,
		onHide
	};

	return <Dialog config={dialogConfig} show={show} t={t} bsSize='large' />;
};

export default NotesDialog;